module.exports = __webpack_public_path__ + "static/media/error.72d2fc39.svg";